/**
 * @fileoverview Axios API client with JWT auth interceptors for ClubOS
 */
import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? `${window.location.origin}/api/v1`
    : "http://localhost:5095/api/v1");

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor - attach JWT
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("clubos_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle 401
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("clubos_token");
      window.location.href = "/authentication/sign-in";
    }
    return Promise.reject(error.response?.data || error);
  }
);

export default apiClient;
